import PropTypes from 'prop-types'
import { CarouselCaption, Container, Row, Col } from 'react-bootstrap'
import config from '../../config/cms'
import Slogan from '../Slogan'
import Applinks from '../Applinks'
import Markdown from '../Markdown'
import BannerButton from './BannerButton'

const BannerItem = ({
  slideProps = {},
  productRef = undefined,
  isActive = false,
  showSlogan = true,
  appLinks = undefined
}) => {
  const {
    image,
    verticalImage,
    title,
    subtitle,
    showAppLinks,
    buttonPrimary,
    buttonSecondary,
    contentPositionDesktop,
    contentPositionMobile,
    isBannerDarkened
  } = slideProps
  const verticalImg = verticalImage?.url || image?.url
  const hasButton = buttonPrimary?.label.length > 0 || buttonSecondary?.label.length > 0

  const getContentPositionDesktopClass = () => {
    switch (contentPositionDesktop) {
      case 'top':
        return 'justify-content-lg-start'

      case 'center':
        return 'justify-content-lg-center'

      case 'bottom':
        return 'justify-content-lg-end'

      default:
        return 'justify-content-lg-center'
    }
  }

  const getContentPositionMobileClass = () => {
    switch (contentPositionMobile) {
      case 'top':
        return 'justify-content-start'

      case 'center':
        return 'justify-content-center'

      case 'bottom':
        return 'justify-content-end'

      default:
        return 'justify-content-start'
    }
  }

  return (
    <div>
      <span
        className="verticalImage"
        style={{
          backgroundImage: verticalImg ? `url(${config.url + verticalImg})` : 'none'
        }}
      />
      {isBannerDarkened && <span className="overlay" />}
      <Container fluid className="container-xxxl slider-content">
        <Row className="slider-row">
          <Col xs={12} lg={6} className="slider-col">
            <CarouselCaption
              className={`position-static text-center text-lg-start d-flex flex-column 
              ${getContentPositionMobileClass()} ${getContentPositionDesktopClass()}`}
            >
              <div className="info-section d-flex flex-column">
                {isActive && (
                  <h1 className="caption-title child-p-m-0">
                    <Markdown>{title}</Markdown>
                  </h1>
                )}
                <div className="caption-sub-title child-p-m-0 mt-2 mt-md-3">
                  <Markdown>{subtitle}</Markdown>
                </div>
                {hasButton && (
                  <Row className="pt-xl-2 align-items-center justify-content-center justify-content-lg-start">
                    {buttonPrimary?.label?.length > 0 && (
                      <Col xs="auto" className="mt-3 mt-md-4">
                        <BannerButton btnProps={buttonPrimary} productRef={productRef} />
                      </Col>
                    )}
                    {buttonSecondary?.label?.length > 0 && (
                      <Col xs="auto" className="mt-3 mt-md-4">
                        <BannerButton btnProps={buttonSecondary} productRef={productRef} />
                      </Col>
                    )}
                  </Row>
                )}
                {showAppLinks && <Applinks appLinks={appLinks} />}
              </div>
              {showSlogan && (
              <div className="d-flex justify-content-center justify-content-lg-start">
                <Slogan />
              </div>
              )}
            </CarouselCaption>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

BannerItem.propTypes = {
  slideProps: PropTypes.instanceOf(Object),
  productRef: PropTypes.instanceOf(Object),
  isActive: PropTypes.bool,
  showSlogan: PropTypes.bool,
  appLinks: PropTypes.instanceOf(Array)
}

export default BannerItem
